module.exports = __webpack_public_path__ + "static/media/allie28.cccc2c56.jpg";